
export const AdminVentasColumnas = [
    {//05
      name: 'Emision',
      selector: 'r_fecemi',
      width: '110px',
      sortable: true,
      cell: row => {
          const isNotaCredito = row.comprobante?.startsWith("07");
          return (
            <span style={{ color: isNotaCredito ? 'skyblue' : 'inherit' }}>
              {row.r_fecemi}
            </span>
          );
      }      
    },
    {//07-08-10
      name: 'Comprobante',
      selector: 'comprobante', //campo unido
      width: '140px',
      compact: true,
      sortable: true,
      cell: row => {
          const isNotaCredito = row.comprobante?.startsWith("07");
          return (
            <span style={{ color: isNotaCredito ? 'skyblue' : 'inherit' }}>
              {row.comprobante}
            </span>
          );
      }      
    },
    {//11
      name: 'Tp',
      selector: 'r_id_doc',
      width: '0px',
      compact: true,
      sortable: true,
    },
    {//12
      name: 'Ruc/Dni',
      selector: 'r_documento_id',
      width: '100px',
      compact: true,
      sortable: true,
    },
    {//13
      name: 'Razon Social',
      selector: 'r_razon_social',
      width: '300px',
      compact: true,
      sortable: true,
    },
    {
      name: 'TOTAL',
      selector: row => row.r_monto_total,
      width: '100px',
      compact: true,
      sortable: true,
      cell: row => {
        const isNotaCredito = row.comprobante?.startsWith("07");

        // Convertimos a número
        let valor = Number(row.r_monto_total) || 0;

        // Formato de miles con coma
        const valorFormateado = valor.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        return (
          <span style={{ color: isNotaCredito ? 'skyblue' : 'inherit' }}>
            {valorFormateado}
          </span>
        );
      }
    },

    {//27 PEN o USD
      name: 'MONEDA',
      selector: 'r_moneda',
      sortable: true,
      compact: true,
      width: '90px',
    },
    {//nuevo
      name: 'EFECTIVO',
      selector: 'efectivo',
      sortable: true,
      width: '80px',
      compact: true
    },
    {//nuevo
      name: 'OTROS',
      selector: 'efectivo2',
      sortable: true,
      compact: true,
      width: '80px',
    },
    {//nuevo
      name: 'PAGO',
      selector: 'forma_pago2',
      sortable: true,
      compact: true
    },
    {//31
      name: 'REFERENCIA',
      selector: 'comprobante_ref',
      sortable: true,
      width: '120px',
      compact: true
    },
    {//31
      name: 'SUNAT',
      selector: 'cdr_descripcion',
      sortable: true,
      width: '350px',
      compact: true
    },
    {//28
      name: 'TC',
      selector: 'r_tc',
      sortable: true,
    },
    {//29
      name: 'REF.Emision',
      selector: 'r_fecemi_ref',
      sortable: true,
    },
    {//33
      name: 'GRE FIRMA',
      selector: 'gre_vfirmado',
      sortable: true,
    },
    {//34
      name: 'GRE',
      selector: 'gre_ref',
      sortable: true,
      width: '150px',
    },
    {//35
      name: 'USER',
      selector: 'ctrl_crea_us',
      sortable: true,
      width: '150px',
    },
    
    // Otras columnas específicas para la vista de Ventas
  ];

  export const AdminKardexColumnas = [
    {//05
      name: 'Emision',
      selector: 'emision',
      width: '120px',
      sortable: true,
    },
    {//05
      name: 'Operacion',
      selector: 'op_contable',
      width: '120px',
      sortable: true,
    },

    {//13
      name: 'Ingreso',
      selector: 'ingreso',
      width: '100px',
      sortable: true,
    },
    {//13
      name: 'Egreso',
      selector: 'egreso',
      width: '100px',
      sortable: true,
    },
    {//13
      name: 'UN',
      selector: 'cont_und',
      width: '70px',
      sortable: true,
    },
    {//13
      name: 'Saldo',
      selector: 'saldo',
      width: '100px',
      sortable: true,
      cell: row => {
          const value = Number(row.saldo);
          return value.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
      },      
      conditionalCellStyles: [
          {
            when: row => Number(row.saldo) < 0,
            style: {
              color: 'orange',
            },
          },
        ],      
    },
    {//07-08-10
      name: 'Comprobante',
      selector: 'comprobante', //campo unido
      width: '150px',
      sortable: true,
    },
    {//12
      name: 'Ruc',
      selector: 'r_documento_id',
      width: '100px',
      sortable: true,
    },
    {//13
      name: 'Razon Social',
      selector: 'r_razon_social',
      sortable: true,
    },
    {//13
      name: 'Id Almacen',
      selector: 'id_almacen',
      sortable: true,
    },    
    {//13
      name: 'Motivo',
      selector: 'nombre',
      sortable: true,
    },
    
    // Otras columnas específicas para la vista de Ventas
  ];

export const getColumnasDet = (tipo = 'ventas') => {
  const columnasBase0 = [
    { name: 'Emision', selector: 'emision', width: '100px', sortable: true },
  ];

  const columnasBase1 = [
    { name: 'UN', selector: 'cont_und', width: '40px', compact: true, sortable: true },
    { name: 'Descripcion', selector: 'descripcion', width: '400px', compact: true, sortable: true },
    { name: 'IMPORTE', selector: 'precio_neto', width: '100px', compact: true,sortable: true },
    { name: 'MONEDA', selector: 'r_moneda', width: '70px', compact: true,sortable: true },
    { name: 'Comprobante', selector: 'comprobante', width: '120px', compact: true,sortable: true },
    { name: 'Id Producto', selector: 'id_producto', width: '100px',compact: true, sortable: true },
    { name: 'Ruc', selector: 'r_documento_id', width: '100px', compact: true,sortable: true },
    { name: 'Razon Social', selector: 'r_razon_social', compact: true,sortable: true },
    { name: 'Id Almacen', selector: 'id_almacen', width: '80px', compact: true,sortable: true },
    { name: 'Motivo', selector: 'nombre', width: '80px', compact: true,sortable: true },
    { name: 'TC', selector: 'r_tc', compact: true,sortable: true },
  ];

  const columnaIngreso = { name: 'Ingreso', selector: 'ingreso', width: '80px', compact: true, sortable: true };
  const columnaEgreso = { name: 'Egreso', selector: 'egreso', width: '80px', compact: true, sortable: true };

  if (tipo === 'ventas') {
    // Solo agregamos la columna Egreso
    return [...columnasBase0, columnaEgreso, ...columnasBase1];
  }

  if (tipo === 'stocks') {
    // Mostramos ambas columnas (Ingreso y Egreso)
    return [...columnasBase0, columnaIngreso, columnaEgreso, ...columnasBase1];
  }

  // Tipo por defecto, todo
  return [...columnasBase0, columnaIngreso, columnaEgreso, ...columnasBase1];
};

  export const AdminInventarioColumnas = [
    {//02
      name: 'Descripcion',
      selector: 'nombre_producto',
      width: '400px',
      compact: true,
      sortable: true,
    },
    {//03
      name: 'Inicial',
      selector: 'saldo_inicial',
      width: '100px',
      sortable: true,
    },
    {//04
      name: 'Ingreso',
      selector: 'ingresos',
      width: '100px',
      sortable: true,
    },
    {//05
      name: 'Egreso',
      selector: 'egresos',
      width: '100px',
      sortable: true,
    },
    {//06
      name: 'Saldo',
      selector: 'saldo',
      width: '100px',
      sortable: true,
    },
    {//07
      name: 'Und',
      selector: 'cont_und',
      width: '80px',
      sortable: true,
    },
    {//08
      name: 'Almacen',
      selector: 'id_almacen',
      width: '80px',
      sortable: true,
    },
    {//01
      name: 'Id Producto',
      selector: 'id_producto',
      width: '0px',
      sortable: true,
    },    
  ];

  export const AdminStocksColumnas = [
    {//05
      name: 'Emision',
      selector: 'fecha_emision',
      width: '100px',
      sortable: true,
    },
    {//07-08-10
      name: 'Comprobante',
      selector: 'comprobante', //campo unido
      width: '150px',
      compact: true,
      sortable: true,
    },
    {//12
      name: 'D',
      selector: 'r_id_doc',
      width: '40px',
      sortable: true,
    },
    {//13
      name: 'Identidad',
      selector: 'r_documento_id',
      width: '110px',
      compact: true,
      sortable: true,
    },
    {//14
      name: 'Razon Social',
      selector: 'r_razon_social',
      width: '200px',
      compact: true,
      sortable: true,
    },
    ///////////////cambio
    {//07-08-10
      name: 'Estado',
      selector: 'estado', //campo unido
      width: '100px',
      compact: true,
      sortable: true,
    },
    {//07-08-10
      name: 'Motivo',
      selector: 'nombre', //campo unido
      width: '200px',
      sortable: true,
      compact: true,
    },
     {//27
      name: 'TC',
      selector: 'r_tc',
      sortable: true,
      compact: true,
    },
     // Otras columnas específicas para la vista de Compras
    //Ya no se usa datos detraccion, pero se podria manejar en campos auxiliar no obligatorios
    //numero_constancia
    //fecha_constancia
    //como en algun tutorial lo sugieren
  ];
  
  export const AdminCajaColumnas = [
    //por diseñar ;)
    {//06
      name: 'Glosa',
      selector: 'glosa',
      sortable: true,
    },
    {//28
      name: 'TC',
      selector: 'r_tc',
      sortable: true,
    },
  ];
  
  export const AdminVentasRefColumnas = [
    {
      name: 'FACTURA',
      selector: row => row.factura,
      sortable: true,
      width: '180px'
    },
    {
      name: 'RUC/DNI',
      selector: row => row.ruc,
      sortable: true,
      width: '130px'
    },
    {
      name: 'RAZÓN SOCIAL',
      selector: row => row.razon_social,
      sortable: true,
      grow: 2
    },
    {
      name: 'FECHA CPE',
      selector: row => row.fecha_comp,
      sortable: true,
      width: '120px'
    },
    {
      name: 'FECHA NV',
      selector: row => row.fecha_nv,
      sortable: true,
      width: '120px'
    },
    {
      name: 'REFERENCIAS',
      selector: row => row.referencias,
      sortable: true,
      width: '140px'
    },
    {
      name: 'MONTO',
      selector: row => Number(row.monto || 0).toFixed(2),
      sortable: true,
      right: true,
      width: '120px'
    },
    {
      name: 'NOMBRE',
      selector: row => row.nombre,
      sortable: true,
      grow: 2
    },
    {
      name: 'ID REF',
      selector: row => row.dni,
      sortable: true,
      width: '130px'
    }
  ];
  